import React from 'react';
import { useParams, useNavigate, useLocation } from 'react-router-dom';
import { ChatSection } from '../chat/ChatSection';
import { useMarkets } from '../../hooks/useMarkets';
import { ArrowLeft } from 'lucide-react';
import { MarketSearches } from './MarketSearches';

export const MarketSearchPage: React.FC = () => {
  const { marketId } = useParams();
  const navigate = useNavigate();
  const location = useLocation();
  const { markets, marketSearches, isLoading } = useMarkets();
  
  const market = markets.find(m => m.id === marketId);
  const searches = marketSearches.filter(s => s.marketId === marketId);
  const { query, searchMetadata } = location.state || {};

  if (isLoading) {
    return (
      <div className="container mx-auto px-0 sm:px-4 py-8">
        <div className="animate-pulse space-y-4">
          <div className="h-8 bg-gray-200 rounded w-32"></div>
          <div className="grid grid-cols-1 lg:grid-cols-3 gap-6">
            <div className="lg:col-span-2">
              <div className="h-96 bg-gray-200 rounded-lg"></div>
            </div>
            <div className="lg:col-span-1">
              <div className="h-96 bg-gray-200 rounded-lg"></div>
            </div>
          </div>
        </div>
      </div>
    );
  }

  if (!market) {
    return (
      <div className="container mx-auto px-0 sm:px-4 py-8">
        <div className="text-center">
          <h2 className="text-2xl font-bold text-gray-900 dark:text-white mb-4">Market Not Found</h2>
          <p className="text-gray-600 dark:text-gray-300 mb-6">The market you're looking for doesn't exist.</p>
          <button
            onClick={() => navigate('/markets')}
            className="inline-flex items-center text-blue-600 hover:text-blue-700 dark:text-blue-400 dark:hover:text-blue-300"
          >
            <ArrowLeft className="w-4 h-4 mr-2" />
            Back to Markets
          </button>
        </div>
      </div>
    );
  }

  return (
    <div className="container mx-auto px-0 sm:px-4 py-8">
      <div className="mb-6 px-4 sm:px-0">
        <button
          onClick={() => navigate('/markets')}
          className="inline-flex items-center text-blue-600 dark:text-blue-400 hover:text-blue-700 dark:hover:text-blue-300"
        >
          <ArrowLeft className="w-4 h-4 mr-2" />
          Back to Markets
        </button>
      </div>

      <div className="grid grid-cols-1 lg:grid-cols-3 gap-6">
        <div className="lg:col-span-2">
          <ChatSection 
            initialQuery={query} 
            autoSearch={!!query}
            searchMetadata={searchMetadata}
          />
          
          {/* On mobile: Market Searches comes after Chat Section */}
          <div className="block lg:hidden mt-6">
            <MarketSearches 
              market={market}
              searches={searches}
            />
          </div>
        </div>
        
        {/* On desktop: Market Searches appears in the right column */}
        <div className="lg:col-span-1 hidden lg:block">
          <div className="sticky top-8">
            <MarketSearches 
              market={market}
              searches={searches}
            />
          </div>
        </div>
      </div>
    </div>
  );
};